import { useState } from "react";
import Conect from "../../../../../Api/Conect";
import NotificationsAlert from "../../../../services/NotificationsAlert";
import "./OperatorTable.css";

const OperatorManager = ({ operators, fetchOperators, token }) => {
    const [form, setForm] = useState({
        id: "",
        name: "",
        apn: "",
        user: "",
        password: ""
    });

    const [editing, setEditing] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    }

    const handleSave = async () => {
        try {
            let res;

            if (editing) {
                res = await Conect.put(`/b3BlcmF0b3J1cGRhdGU=${token}`, form);
            } else {
                res = await Conect.post(`/b3BlcmF0b3JjcmVhdA==${token}`, form);
            }

            if (res.data.erro) {
                NotificationsAlert("warning", "Erro", res.data.msg);
                return;
            }

            NotificationsAlert("success", "Sucesso", res.data.msg);

            setForm({ id: "", name: "", apn: "", user: "", password: "" });
            setEditing(false);
            fetchOperators();

        } catch (err) {
            NotificationsAlert("error", "Erro", "Falha ao salvar");
        }
    };

    const handleEdit = (op) => {
        setForm(op);
        setEditing(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Deseja remover?")) return;

        const res = await Conect.delete(`/ZGVsZXRlb3BlcmF0b3I=${token}`, {
            data: { id }
        });

        if (!res.data.erro) {
            NotificationsAlert("success", "Sucesso", res.data.msg);
            fetchOperators();
        }
    };

    return (
        <div className="operator-manager">
            <h2>Gerenciamento de Chips</h2>

            <div className="form-inline">
                <input name="name" placeholder="Nome" value={form.name} onChange={handleChange} />
                <input name="apn" placeholder="APN" value={form.apn} onChange={handleChange} />
                <input name="user" placeholder="Usuário" value={form.user} onChange={handleChange} />
                <input name="password" placeholder="Senha" value={form.password} onChange={handleChange} />

                <button onClick={handleSave}>
                    {editing ? "Atualizar" : "Adicionar"}
                </button>
            </div>

            <table className="operator-manager">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>APN</th>
                        <th>Usuário</th>
                        <th>Senha</th>
                        <th>Ações</th>
                    </tr>
                </thead>

                <tbody>
                    {operators.map(op => (
                        <tr key={op.id}>
                            <td>{op.name}</td>
                            <td>{op.apn}</td>
                            <td>{op.user}</td>
                            <td>{op.password}</td>

                            <td>
                                <button onClick={() => handleEdit(op)}>✏️</button>
                                <button onClick={() => handleDelete(op.id)}>🗑️</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default OperatorManager;